import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
    // 'Backend' 플러그인: 번역 파일을 public/locales... 에서 불러옵니다.
    .use(Backend)
    // 'LanguageDetector' 플러그인: 브라우저 언어를 자동으로 감지합니다.
    .use(LanguageDetector)
    // 'initReactI18next' 플러그인: i18n 인스턴스를 react-i18next에 전달합니다.
    .use(initReactI18next)
    .init({
        // 지원할 언어 목록
        supportedLngs: ['en', 'ko'],
        // 기본 언어 (감지 실패 시)
        fallbackLng: 'en',
        // 'translation' 네임스페이스를 기본으로 사용
        ns: ['translation'],
        defaultNS: 'translation',

        // 언어 감지기 설정
        detection: {
            // 감지 순서: 1. querystring (ex: ?lng=ko) 2. cookie 3. localStorage 4. navigator (브라우저 설정)
            order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
            // 감지된 언어를 저장할 위치
            caches: ['cookie', 'localStorage'],
        },

        // 백엔드(번역 파일) 설정
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },

        // 리액트 앱과 잘 통합되도록 설정
        react: {
            useSuspense: true, // 번역 파일 로딩 중 Suspense 사용
        },
    });

// 문서 lang 속성을 현재 언어와 동기화 (SEO·접근성)
i18n.on('languageChanged', (lng) => {
    document.documentElement.lang = lng;
});
if (i18n.resolvedLanguage) {
    document.documentElement.lang = i18n.resolvedLanguage;
}

export default i18n;
